import { createClient } from '@supabase/supabase-js'
import type { Database } from '@quoter/shared/generated/db-types'
import { env } from './env'

export const supabase = createClient<Database>(
  env.VITE_PUBLIC_SUPABASE_URL,
  env.VITE_PUBLIC_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Magic-link and OAuth both land back on /login with the session in the
      // URL fragment; the client picks it up from there.
      detectSessionInUrl: true,
    },
  },
)

export type SupabaseClient = typeof supabase
export type { Database }
